
// import {
//   GETINTRESTEDCANDIDATE,
//   CREATEINTRESTEDCANDIDATE,
//   UPDATEINTRESTEDCANDIDATE,
//   DELETEINTRESTEDCANDIDATE,

// } from "../actions/type";

// const initialState = {};

// // eslint-disable-next-line import/no-anonymous-default-export
// export default function (state = initialState, action) {
//   switch (action.type) {
//     // Setup partyTypeList Cases
//     case GETINTRESTEDCANDIDATE:
//       return {
//         ...state,
//         intrestedcandidate: action.payload.data,
//       };
//     case CREATEINTRESTEDCANDIDATE:
//       return {
//         ...state,
//         createintrestedcandidate: action.payload.success,
//       };
//     case UPDATEINTRESTEDCANDIDATE:
//       return {
//         ...state,
//         updateintrestedcandidate: action.payload.success,
//       };
//     case DELETEINTRESTEDCANDIDATE:
//       return {
//         ...state,
//         deleteintrestedcandidate: action.payload.success,
//       };

//     default:
//       return state;
//   }
// }
import {
  GETINTRESTEDCANDIDATE,
  CREATE_INTRESTED_CANDIDATE_REQUEST,
  CREATE_INTRESTED_CANDIDATE_SUCCESS,
  CREATE_INTRESTED_CANDIDATE_FAIL,
  UPDATEINTRESTEDCANDIDATE,
  DELETEINTRESTEDCANDIDATE,
} from "../actions/type";

const initialState = {
  intrestedcandidate: [],           // लिस्ट साठवण्यासाठी
  createintrestedcandidate: null,   // Success Flag (true/false)
  updateintrestedcandidate: null,
  deleteintrestedcandidate: null,
  loading: false,                   // लोडिंग इंडिकेटरसाठी
  error: null,                      // **Error (409 Duplicate) साठवण्यासाठी**
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    
    // --- 1. GET ALL CANDIDATES ---
    case GETINTRESTEDCANDIDATE:
      return {
        ...state,
        intrestedcandidate: action.payload.data,
      };

    // --- 2. CREATE REQUEST (जेव्हा सबमिट बटन दाबले जाते) ---
    case CREATE_INTRESTED_CANDIDATE_REQUEST:
      return {
        ...state,
        loading: true,                  // लोडिंग सुरू
        error: null,                    // जुने एरर क्लिअर करा
        createintrestedcandidate: null, // जुने success status क्लिअर करा
      };

    // --- 3. CREATE SUCCESS (जेव्हा डेटा यशस्वीरीत्या सेव्ह होतो) ---
    case CREATE_INTRESTED_CANDIDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        createintrestedcandidate: true, // किंवा action.payload.success
        error: null,
      };

    // --- 4. CREATE FAIL (जेव्हा 409 Duplicate किंवा इतर एरर येतो) ---
    case CREATE_INTRESTED_CANDIDATE_FAIL:
      return {
        ...state,
        loading: false,
        createintrestedcandidate: false,
        // इथे action.payload मध्ये { status: 409, message: "Duplicate..." } येईल
        error: action.payload, 
      };

    // --- 5. UPDATE ---
    case UPDATEINTRESTEDCANDIDATE:
      return {
        ...state,
        updateintrestedcandidate: action.payload.success,
      };

    // --- 6. DELETE ---
    case DELETEINTRESTEDCANDIDATE:
      return {
        ...state,
        deleteintrestedcandidate: action.payload.success,
      };

    default:
      return state;
  }
}